import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed } from 'vue';

import { PerformanceChart } from '@/modules/wealth/components/PerformanceChart';
import { PerformanceHeader } from './components/PerformanceHeader';

import {
  getWealthChart,
  PortfolioChartAxisX,
  PortfolioChartAxisY,
  PortfolioChartFilter,
  WealthChartParams,
  PortfolioChartSummary
} from '@/modules/wealth/services/portfolio';

import { getFilterOptions } from '@/modules/wealth/views/IndexPortfolio/helpers';

import { calculateChartHeight } from '@/modules/wealth/helpers/calculate-height-chart';


export default /*#__PURE__*/_defineComponent({
  __name: 'Performance',
  setup(__props) {

const isLoading = ref(true);
const hasError = ref(false);
const periodFilters = ref<PortfolioChartFilter[]>([]);
const benchmarkFilters = ref<PortfolioChartFilter[]>([]);
const portfolioChartSummary = ref<PortfolioChartSummary | null>(null);
const chartAxisX = ref<PortfolioChartAxisX[]>([]);
const chartAxisY = ref<PortfolioChartAxisY[]>([]);
const isChartAnimationInProgress = ref(false);

const portfolioParams = computed<WealthChartParams>(() => {
  return {
    periodFilter: getActiveFilter(periodFilters.value),
    benchmark: getActiveFilter(benchmarkFilters.value)
  };
});

const isHeaderLoading = computed(() => {
  return isLoading.value || isChartAnimationInProgress.value;
});

const isChartLoading = computed(() => {
  return (
    isLoading.value &&
    chartAxisX.value.length === 0 &&
    chartAxisY.value.length === 0
  );
});

const height = computed(() => {
  return calculateChartHeight(window.innerHeight);
});

async function fetchWealthChart() {
  isLoading.value = true;
  hasError.value = false;

  try {
    const chart = await getWealthChart(portfolioParams.value);

    periodFilters.value = getFilterOptions(chart.periodFilters);
    benchmarkFilters.value = getFilterOptions(chart.benchmarks);
    portfolioChartSummary.value = chart.summary;
    chartAxisX.value = chart.axisX;
    chartAxisY.value = chart.axisY;
  } catch (error) {
    hasError.value = true;
    isChartAnimationInProgress.value = false;
  } finally {
    isLoading.value = false;
  }
}

function handleOnAnimationStateChange(isAnimationInProgress: boolean) {
  isChartAnimationInProgress.value = isAnimationInProgress;
}

function getActiveFilter(filters: PortfolioChartFilter[] | null) {
  if (!filters) {
    return '';
  }

  return filters.find(filter => filter.active)?.key;
}

async function handleBenchmarkFilterChange(value: string) {
  benchmarkFilters.value = benchmarkFilters.value.map(filter => ({
    ...filter,
    active: filter.value === value
  }));

  await fetchWealthChart();
}

async function handlePeriodFilterChange(value: string) {
  periodFilters.value = periodFilters.value.map(filter => ({
    ...filter,
    active: filter.value === value
  }));

  await fetchWealthChart();
}

onMounted(async () => {
  await fetchWealthChart();
});

return { __sfc: true,isLoading, hasError, periodFilters, benchmarkFilters, portfolioChartSummary, chartAxisX, chartAxisY, isChartAnimationInProgress, portfolioParams, isHeaderLoading, isChartLoading, height, fetchWealthChart, handleOnAnimationStateChange, getActiveFilter, handleBenchmarkFilterChange, handlePeriodFilterChange, PerformanceChart, PerformanceHeader }
}

})